(function () {
  'use strict';

  var SECTION_ID = 'main-collection-product-grid';

  class HesedInfiniteScroll {
    constructor() {
      this.grid     = document.getElementById('product-grid');
      this.sentinel = document.getElementById('hesed-scroll-sentinel');
      if (!this.grid || !this.sentinel) return;

      this.nextUrl = this.sentinel.dataset.nextUrl || null;
      this.loading = false;
      this.loader  = document.getElementById('hesed-scroll-loader');

      document.querySelectorAll('.pagination').forEach(function(el) { el.hidden = true; });

      if (!this.nextUrl) return;

      this._onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this._onScroll, { passive: true });
      this.onScroll();
    }

    onScroll() {
      if (this.loading || !this.nextUrl) return;
      var scrolled   = window.scrollY + window.innerHeight;
      var threshold  = document.documentElement.scrollHeight - 800;
      if (scrolled >= threshold) this.loadNext();
    }

    loadNext() {
      var self = this;
      self.loading = true;
      if (self.loader) self.loader.removeAttribute('hidden');

      // Use Shopify's Section Rendering API — returns JSON with section HTML only,
      // avoiding full-page parse issues and intermittent CDN error pages.
      var sep      = self.nextUrl.includes('?') ? '&' : '?';
      var url      = self.nextUrl + sep + 'sections=' + SECTION_ID;

      fetch(url)
        .then(function(res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function(data) {
          var sectionHtml = data[SECTION_ID];
          if (!sectionHtml) throw new Error('section missing in response');

          var doc     = new DOMParser().parseFromString(sectionHtml, 'text/html');
          var newGrid = doc.getElementById('product-grid');

          if (newGrid) {
            // Snapshot to a static array first — newGrid.children is live and
            // shrinks as items are moved, causing every other item to be skipped.
            var items = Array.prototype.slice.call(newGrid.children);
            items.forEach(function(item) {
              self.grid.appendChild(item);
            });
          }

          var newSentinel = doc.getElementById('hesed-scroll-sentinel');
          self.nextUrl    = (newSentinel && newSentinel.dataset.nextUrl) || null;

          if (!self.nextUrl) {
            window.removeEventListener('scroll', self._onScroll);
            if (self.sentinel) self.sentinel.remove();
          }
        })
        .catch(function(err) {
          console.warn('[HESED] Infinite scroll error:', err);
          document.querySelectorAll('.pagination').forEach(function(el) { el.hidden = false; });
          window.removeEventListener('scroll', self._onScroll);
        })
        .finally(function() {
          self.loading = false;
          if (self.loader) self.loader.setAttribute('hidden', '');
          if (self.nextUrl) self.onScroll();
        });
    }
  }

  function init() {
    new HesedInfiniteScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
